import React from 'react'
import StudioManager from '../Studio/StudioManager'

function Videos() {
  return (
    <div className='w-full'><StudioManager/></div>
  )
}

export default Videos